<template>
  <v-tabs
    v-model="activeTab"
    vertical
    background-color="colorNeutralsNavy50"
    active-class="v-btn--active"
    class="fill-height"
  >
    <v-tab
      v-for="tab in enabledTabs()"
      :key="`${tab.name}-tab`"
      :to="`#${tab.route}`"
      class="text-capitalize"
    >
      <v-icon left>
        {{ tab.icon }}
      </v-icon>
      {{ tab.name }}
    </v-tab>

    <v-tabs-items v-model="activeTab">
      <v-tab-item
        v-for="tab in allTabs"
        :key="`${tab.name}-tabitem`"
        :value="tab.route"
      >
        <component :is="tab.component" :is-active="activeTab === tab.route" />
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>

<script>
import ContentHeader from "@/views/ContentHeader.vue";
import QA from "@/views/qa/QA.vue";
import Jobs from "@/views/admin/Jobs.vue";
import VendorGroupManager from "@/views/admin/VendorGroupManager.vue";
import Invoices from "@/views/admin/Invoices.vue";
import AdminReports from "@/views/admin/AdminReports.vue";
import AdminImport from "@/views/admin/AdminImport.vue";
import AdminGrouping from "@/views/admin/AdminGrouping.vue";
import EnrollmentDueDateImport from "@/views/admin/EnrollmentDueDateImport.vue";
import SignupCodeSearch from "@/views/admin/SignupCodeSearch.vue";
import MonitorAlertBulkResolve from "@/views/admin/MonitorAlertBulkResolve.vue";
import FeatureFlags from "@/views/admin/FeatureFlags.vue";
import TestAdminUI from "@/views/admin/TestAdminUI.vue";
import PriceTiers from "@/views/admin/PriceTiers.vue";

//user permissions were checked at the route level
//admins should have access to all tabs
const allTabs = [
  {
    route: "jobs",
    name: "Jobs",
    component: Jobs,
    icon: "mdi-progress-clock"
  },
  {
    route: "qa",
    name: "QA",
    component: QA,
    icon: "mdi-test-tube"
  },
  {
    route: "vendor-group-manager",
    name: "VGM",
    component: VendorGroupManager,
    icon: "mdi-group"
  },
  {
    route: "invoices",
    name: "Invoices",
    component: Invoices,
    icon: "mdi-receipt-text-outline"
  },
  {
    name: "Reports",
    route: "reports",
    component: AdminReports,
    icon: "mdi-chart-line"
  },
  {
    name: "Import",
    route: "import",
    component: AdminImport,
    icon: "mdi-import"
  },
  {
    name: "Grouping",
    route: "grouping",
    component: AdminGrouping,
    icon: "mdi-format-list-group"
  },
  {
    name: "Resolve Monitor Alerts",
    route: "resolveMonitorAlerts",
    component: MonitorAlertBulkResolve,
    icon: "mdi-note-alert-outline"
  },
  {
    name: "Enrollment Due Date Import",
    route: "enrollmentDueDate",
    component: EnrollmentDueDateImport,
    icon: "mdi-clipboard-text-clock"
  },
  {
    name: "Signup Code",
    route: "signupCode",
    component: SignupCodeSearch,
    icon: "mdi-link-box-outline"
  },
  {
    name: "Feature Flags",
    route: "featureFlags",
    component: FeatureFlags,
    icon: "mdi-rocket-launch-outline"
  },
  {
    name: "Feature Flags Test",
    route: "featureFlagsTest",
    component: TestAdminUI,
    icon: "mdi-traffic-cone"
  },
  {
    name: "Price Tiers",
    route: "priceTiers",
    component: PriceTiers,
    icon: "mdi-cash-multiple"
  }
];

export default {
  name: "Admin",
  components: {
    ContentHeader
  },
  data: () => ({
    allTabs: allTabs,
    activeTab: null
  }),
  methods: {
    enabledTabs() {
      const enabledTabs = [];
      for (let tab of allTabs) {
        if (this.isTabEnabled(tab)) {
          enabledTabs.push(tab);
        }
      }
      return enabledTabs;
    },
    isTabEnabled(tab) {
      if ("QA" === tab.name) {
        return !this.$store.getters.inProduction;
      } else if ("Feature Flags Test" === tab.name) {
        return this.isFeatureEnabled("TEST_FEATURE");
      }
      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .v-tabs-items {
  background-color: transparent;
}

.v-tab {
  margin-right: auto;
}
</style>
